module.exports = __webpack_public_path__ + "images/graphic-mall-3@2x_056f6a69f5a6ae56e9ac1ed1410f0e9a.png";